import * as fb from 'firebase'

class User {
	constructor (id) {
		this.id = id   //сюда попадает user.uid понять как создаестся

	}
}

export default {
	state:{
		user: null  //возможна ошибка здесь форм овенер ID null по умолч нул его долж менять мутатион
	},
	mutations:{
		setUser (state, payload) {
			state.user = payload
		}
	},
	actions:{
		async regiserUser ({commit}, {email, password}) {
			commit('clearError')
			commit('setLoading', true)

			try {
				const user = await fb.auth().createUserWithEmailAndPassword(email, password) //метод auth дает возм взаимодействовать с пользователем ур16
				 	commit('setUser', new User(user.user.uid))  //было  user.uid
					console.log('user.uid=' + user.user.uid)	//uid возвращает ФБ при созд пользователя но уже наверно не возвр
					console.log(user)
					console.log(user.user.uid)
					console.log(user.user.l)
					console.log(user.user.a)
					console.log(user.user.o)
					commit('setLoading', false)
			} catch (error) {
					commit('setLoading', false)
					commit('setError', error.message)
					throw error
			}
			  
		},
		async loginUser ({commit}, {email, password}) {
			commit('clearError')
			commit('setLoading', true)

			try {
				const user = await fb.auth().signInWithEmailAndPassword(email, password) //метод auth дает возм взаимодействовать с пользователем ур16
				 	commit('setUser', new User(user.user.uid))   //было  user.uid
					commit('setLoading', false)
			} catch (error) {
					commit('setLoading', false)
					commit('setError', error.message)
					throw error
			}

		},
		autoLoginUser ({commit}, payload){
			commit('setUser', new User(payload.uid)) //не понятно
		},
		logoutUser({commit}){    //говорим фб что нужно сделать сайнаут
			fb.auth().signOut()
			commit('setUser', null)
		}

	},
	getters:{
		user (state) {
			return state.user
		},
		isUserLoggedIn (state) {
			return state.user !== null
		}
	}
}